module.exports = __webpack_public_path__ + "img/logo-right.3503116f.png";